var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 24.6094C21.5203 24.6094 23.9688 22.1609 23.9688 19.1406C23.9688 16.1203 21.5203 13.6719 18.5 13.6719C15.4797 13.6719 13.0312 16.1203 13.0312 19.1406C13.0312 22.1609 15.4797 24.6094 18.5 24.6094Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7969 15.8594C29.0707 15.8573 30.3275 16.1528 31.4669 16.7225C32.6063 17.2922 33.5968 18.1203 34.3594 19.1406",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64062 19.1406C3.40324 18.1203 4.39374 17.2922 5.53313 16.7225C6.67251 16.1528 7.92926 15.8573 9.20312 15.8594",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 29.5313C11.3453 28.0562 12.4653 26.8131 13.8576 25.9435C15.2499 25.074 16.8585 24.6129 18.5 24.6129C20.1415 24.6129 21.7501 25.074 23.1424 25.9435C24.5347 26.8131 25.6547 28.0562 26.375 29.5313",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20268 15.8594C8.37231 15.8602 7.55885 15.6247 6.85734 15.1804C6.15583 14.7361 5.59525 14.1014 5.2411 13.3503C4.88695 12.5992 4.75386 11.7629 4.85737 10.939C4.96088 10.1151 5.29673 9.33767 5.82567 8.69756C6.3546 8.05745 7.05478 7.58108 7.8444 7.32412C8.63401 7.06716 9.48045 7.04022 10.2848 7.24645C11.0892 7.45268 11.8182 7.88356 12.3868 8.48874C12.9554 9.09392 13.34 9.84842 13.4957 10.6641",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5039 10.6641C23.6596 9.84842 24.0442 9.09392 24.6128 8.48874C25.1813 7.88356 25.9104 7.45268 26.7148 7.24645C27.5191 7.04022 28.3655 7.06716 29.1552 7.32412C29.9448 7.58108 30.645 8.05745 31.1739 8.69756C31.7028 9.33767 32.0387 10.1151 32.1422 10.939C32.2457 11.7629 32.1126 12.5992 31.7585 13.3503C31.4043 14.1014 30.8437 14.7361 30.1422 15.1804C29.4407 15.6247 28.6272 15.8602 27.7969 15.8594",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.bbbcf42a202ffdb9ec4c8dfbfe9e5d2b.svg";
export { ForwardRef as ReactComponent };